// Translations
import form from '../sections/form/translations/en'

// Translation: Reset > Landing (English)
export default Object.freeze({
	sections: { form }
})
